import { z } from 'zod';

/** `GET /health/live` — the process is up (api-design §3.1). */
export const healthLiveResponseSchema = z.object({
  status: z.literal('ok'),
});

/** `GET /health/ready` — every dependency answered (200) or at least one did not (503). */
export const healthReadyResponseSchema = z.object({
  status: z.enum(['ok', 'unavailable']),
  checks: z.record(z.string(), z.enum(['ok', 'failed'])),
});

export type HealthLiveResponse = z.infer<typeof healthLiveResponseSchema>;
export type HealthReadyResponse = z.infer<typeof healthReadyResponseSchema>;
